"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./EstimateModule.css");

var _styles = {
  "wrapper": "EstimateModule__wrapper___moP3L",
  "container": "EstimateModule__container___3HhY8"
};

const styles = _bind.default.bind(_styles);

const EstimateModule = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  title,
  titleTooltip,
  currentEstimate,
  previousEstimate,
  previousDescription,
  description,
  isLoading,
  isFinalCredit
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  return _react.default.createElement("div", {
    className: styles('wrapper')
  }, _react.default.createElement(_.Flex, {
    "data-testid": dataTestId,
    className: composed_classname,
    padding: [16, 24],
    direction: 'column',
    gap: 16
  }, isLoading ? _react.default.createElement(_.Flex, {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  }, _react.default.createElement(_.Spinner, {
    size: 'small'
  })) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Flex, {
    gap: 4,
    direction: 'column'
  }, _react.default.createElement(_.Flex, null, _react.default.createElement(_.Text, {
    tag: 'span',
    variant: 'medium',
    size: 15
  }, title), titleTooltip && _react.default.createElement(_.Tooltip, {
    text: titleTooltip,
    position: 'top'
  }, _react.default.createElement(_.Icon, {
    name: _.IconEnum.info_circle_outline,
    color: _.Color.neutral._60
  }))), _react.default.createElement(_.Text, {
    variant: 'bold',
    size: 32,
    color: isFinalCredit ? _.Color.green._70 : _.Color.neutral._90
  }, currentEstimate), previousEstimate && previousDescription && _react.default.createElement(_.Text, null, _react.default.createElement(_.Text, {
    variant: 'medium',
    tag: 'span'
  }, previousEstimate, ' '), _react.default.createElement(_.Text, {
    variant: 'medium',
    tag: 'span',
    color: _.Color.lime._80
  }, previousDescription))), description && _react.default.createElement(_.Text, {
    text: description,
    size: 13
  }))));
});
var _default = EstimateModule;
exports.default = _default;